import { render, staticRenderFns } from "./three.vue?vue&type=template&id=3e60e11d&scoped=true"
import script from "./three.vue?vue&type=script&lang=js"
export * from "./three.vue?vue&type=script&lang=js"
import style0 from "./three.vue?vue&type=style&index=0&id=3e60e11d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.20_css-loader@6.11.0_webpack@5.101.3__lodash@4_926e3ab2bffa66a29e90045929af258e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e60e11d",
  null
  
)

export default component.exports